import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import php from "../assets/PHP-logo.webp";
import react from "../assets/React.webp";
import sapli from "../assets/sapli.png";
import bignephew from "../assets/bignephew.svg";
import Item from './Item'
import './Projects.css'

const Project = () => {
    return (
        <div className='projects-container'>
            <Row>
                <h2 className='text-light d-flex justify-content-center'>Quelques réalisations publiques:</h2>
            </Row>
            <Row className='projects justify-content-center'>
                <Item title="SAPLI" imageUrl={sapli} redirectUrl="https://github.com/balkohv/SAPLI" />
                <Item title="Portfolio" imageUrl={react} redirectUrl="https://github.com/balkohv/portfolio"/>
                {/* <Col xs={2}
                    <Item title="Gestion de cabinet médical (scolaire)" imageUrl={php} redirectUrl="https://github.com/balkohv/Projet_php"/>
                </Col> */}
                <Item title="BigNephew" imageUrl={bignephew} redirectUrl="https://github.com/balkohv/Big_nephew"/>
            </Row>
        </div>
    );
};

export default Project;